

import '../pages/SettingPageuser.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";

import { loginSuccessP } from "../redux/slices/pensSlice";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import apiService from "../api/ApiService";
import { Close } from '@mui/icons-material';
const moment=require('moment-jalaali');


const DeletePen=({penr})=>{
    const {currentPens}=useSelector(state=>state.pens)
   
    const {openDeleteModal,closedeleteModal,isDeleteModalOpen}=useGlobalContext();
   
    
    const dispatch=useDispatch();
    
 
    const deleteFarm=async()=>{           
                
                const res=await apiService.deletePen(penr.id);
                
                
                    const filter=currentPens.filter(item=>{
                        return item.id!==penr.id
                    })
                    dispatch(loginSuccessP(filter))
                    openDeleteModal()
                    
                
    }
    

    return <div onClick={closedeleteModal} className={`modal-overlay ${isDeleteModalOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <PriorityHighIcon fontSize='large'/>

            <h4 >آیا از حذف این بهاربند مطمئن هستید؟</h4>
            </div>
       
        
        <button className="EditMOdalBtnForm" onClick={deleteFarm}>
            تایید
        </button>
        
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
        
    </div>
}
export default DeletePen